import { useRef, useEffect } from "react";

function TextArea({
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled = false,
  onFocus,
  onBlur,
  style = {},
  inputRef,
  theme = {},
}) {
  const internalRef = useRef(null);
  const textareaRef = inputRef || internalRef;

  useEffect(() => {
    if (textareaRef.current ) {
      if ( textareaRef.current.value.length > 0) {
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
        
      }
      else {
        textareaRef.current.style.height = "44px"
      }
    }
    
  }, [value, textareaRef]);

  const defaultTheme = {
    textColor: "#111827",
    backgroundColor: "#ffffff",
    borderColor: "#181818",
    primaryColor: "#6366f1",
    ...theme,
  };

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      style={{
        overflow:"hidden",
        width: "100%",
        padding: "12px 15px",
        border: `1px solid #d1d5db`,
        borderRadius: "4px",
        resize: "none",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: "16px",
        color: defaultTheme.textColor,
        backgroundColor: defaultTheme.backgroundColor,
        outline: "none",
        minHeight: "44px",
        maxHeight:"600px",
        ...style,
      }}
    />
  );
}

export default TextArea;
